<div class="grid-x">
  <div class="cell small-12 large-6 medium-6">
    <b>Resend</b> invitation to new users
  </div>
  <div class="cell small-12 large-6 medium-6 save-cancel-button-group">
    <button class="iana-button-empty-bg" (click)="resendInvite()">Resend</button>
  </div>
</div>
<ngx-smart-modal [customClass]="'msg-modal'" identifier="{{randomNewUsersID}}" [closable]="false"
                 [dismissable]="false" [escapable]="false">
  <div class="modal-header">
    Resend invitations
  </div>
  <div class="user-invite-form">
    <div class="select-user-box">
      <label for="users-select-box">Resend invitations to:</label>
      <select id="users-select-box" [(ngModel)]="userToInvite" class="select-box" name="users-select-box">
        <option *ngFor="let user of usersToInvite" [ngValue]="user">
          {{ user.firstName }} {{ user.lastName }}
        </option>
      </select>
    </div>
    <div class="save-cancel-button-group" style="margin-top: 16px;">
      <button class="iana-button-cancel" type="reset" (click)="close()">Cancel
      </button>
      <button class="iana-button" type="submit" (click)="confirmResendInvite()">Resend</button>
    </div>
  </div>
</ngx-smart-modal>
